import axios from 'axios';

const API_URL = `${process.env.VUE_APP_HOST}/api/surveytemplate`;

export const surveyTemplateApi = {
  getAll: async () => {
    const response = await axios.get(API_URL);
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
  },

  create: async (template) => {
    const response = await axios.post(API_URL, template);
    return response.data;
  },

  update: async (id, template) => {
    const response = await axios.put(`${API_URL}/${id}`, template);
    return response.data;
  },

  delete: async (id) => {
    await axios.delete(`${API_URL}/${id}`);
  }
};

